<template>
	<div id="app">
		<div class="wrap-container">
			<div class="header-box">
				<div v-show="!showAside" class="logo">
					<img src="./assets/img/toplogo.png" alt />
				</div>
				<!-- <el-menu
					:default-active="defaultActive"
					class="el-menu-demo"
					mode="horizontal"
					@select="handleSelect"
					:router="router"
				>
					<el-menu-item index="/">首页</el-menu-item>
					<el-menu-item index="/products">产品目录</el-menu-item>
					<el-menu-item index="/product">产品介绍</el-menu-item>
					<el-menu-item index="/productCertificate">产品证书</el-menu-item>
					<el-menu-item index="/Certificate">授权证书</el-menu-item>
				</el-menu> -->
				<my-menu v-if="deviceType === 'desktop'" />
				<i
					v-if="deviceType === 'mobile'"
					class="el-icon-s-fold"
					:class="showAside ? 'top-left' : ''"
					style="font-size: 36px"
					@click="toggleAside"
				></i>

				<el-collapse-transition>
					<my-menu v-show="showAside" mode="vertical" />
				</el-collapse-transition>
			</div>
			<el-main v-show="!showAside">
				<router-view v-f="deviceType === 'desktop'" />
			</el-main>
			<div class="footer" v-if="isShow && !showAside">
				<div class="footer-content">
					<ul class="content-nav">
						<li>
							<p>联系我们</p>
							<span>联系人：刘先生</span>
							<span>电话：13235915999</span>
							<span v-show="deviceType == 'desktop'"
								>地址：福建省福州市晋安区化工路1号 泰禾金府天境2415</span
							>
							<span v-show="deviceType == 'mobile'"
								>地址：福建省福州市晋安区化工路1号</span
							>
							<div v-show="deviceType == 'mobile'">泰禾金府天境2415</div>
						</li>
					</ul>
					<img src="./assets/img/ercode.png" alt />
				</div>
				<!-- <div class="copyright">
					<span>xx版权所有</span>
				</div> -->
			</div>
		</div>
	</div>
</template>

<script>
import MyMenu from './components/MyMenu.vue'
import Bus from './components/bus.js'

export default {
	components: {
		MyMenu,
	},
	data() {
		return {
			router: true,
			defaultActive: '/Home',
			isShow: true,
			deviceType: 'desktop',
			showAside: false,
			defaultRoute: 'home',
		}
	},
	created() {
		this.checkDeviceType()
		window.addEventListener('resize', this.checkDeviceType)
	},
	mounted() {
		Bus.$on('changePage', (param) => {
			this.$router.push({ name: param })
			this.showAside = false
		})
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.checkDeviceType)
	},
	methods: {
		handleSelect(key) {
			this.isShow = this.defaultActive != key
		},
		checkDeviceType() {
			if (window.matchMedia('(max-width: 768px)').matches) {
				this.deviceType = 'mobile'
			} else {
				this.deviceType = 'desktop'
			}
		},
		toggleAside() {
			this.showAside = !this.showAside
		},
	},
}
</script>

<style lang="scss">
* {
	padding: 0;
	margin: 0;
}
html,
body {
	width: 100vw;
	height: 100vh;
}

#app {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #2c3e50;
}

.wrap-container {
	.header-box {
		box-sizing: border-box;
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100vw;
		margin: 0 auto;
		padding-right: 10px;
		//background-color: #fff;

		.logo {
			width: 280px;
			padding: 10px;

			img {
				width: 100%;
				line-height: 60px;
			}
		}

		.top-left {
			position: fixed;
			top: 10px;
			left: 10px;
		}
	}
	.el-main {
		padding: 0 !important;
	}

	.footer {
		width: 100%;
		height: 216px;
		overflow: hidden;
		background-color: #14679f;
		&-content {
			width: 1240px;
			margin: 0 auto;
			padding-top: 20px;
			display: flex;
			justify-content: space-between;
			.content-nav {
				display: flex;
				justify-content: space-around;
				li {
					display: flex;
					flex-direction: column;
					padding: 0 20px;
					//justify-content: center;
					align-items: flex-start;
					p {
						font-size: 20px;
						color: #d4edff;
						padding: 10px 0;
					}
					span {
						color: #f7f7f7;
						font-weight: 300;
						padding: 5px 0;
					}
					div {
						color: #f7f7f7;
						font-weight: 300;
						padding: 5px 0 0 50px;
					}
				}
			}
			img {
				width: 170px;
				height: 170px;
				padding: 10px;
			}
		}
		.copyright {
			height: 30px;
			background: #125688;
			span {
				color: #fff;
				line-height: 30px;
			}
		}
	}
}

@media (max-width: 768px) {
	.wrap-container {
		.header-box {
			padding-right: 0;
		}
	}
}
</style>
